import { copyTextToClipboard } from '@knots/shared-frontend'
import { useCallback } from 'react'

export const useCopyUrlToClipboard = (templateId: number) => {
  const getUrl = (id: number) => `${location.origin}/routes/new?template_id=${id}`

  return useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation()
      const url = getUrl(templateId)
      copyTextToClipboard(url)
    },
    [templateId]
  )
}
